<template lang="html">
  <div class="assistance" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back8.png` +')'}">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>
    
    <div class="assistancePeople">
      <input type="number" class="phoneInput" placeholder="写下您接收福利的电话" name="phoneInput" v-model="phone">
      <div class="securityCodeInput">
        <input type="text" placeholder="小小验证码" name="securityCode" v-model="smsCode">
        <p @click="getSmsCode">{{buttonMsg}}</p>
      </div>
            
      <div class="beginBtn" @click="goLogin">
        去助力 免费领桌垫
      </div>
    </div>
    
    <img :src="`${pagebase}/static/img/assistances/back9.png`" alt="" class="elseGift">
    
    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>
    
    <div class="helpShow" v-show="helpShow">
      <div class="informerCon">
        <p class="informerInfo">同一手机号只能助力一次哦~</p>
        <p class="informerClose" @click="goMyself">我知道了</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    pagebase
  } from '@/utils/http.js';
  import utils from '@/utils/utils.js';
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare'

  export default {
    data() {
      return {
        pagebase: pagebase,
        informerShow: 0,
        helpShow: false,
        
        phone: '',
        smsCode: '',
        limitTime: 60,
        buttonMsg: '发送验证码',
      }
    },
    
    mounted(){
      new WxShare().share({
        title: '0元领超大半导体图谱桌垫',
        desc: '2000+电子工程师已领取',
        link: pagebase + '/#/assistances?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId,
        imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
      });
      
      if(Cookies.get('help_activity_reg_id')){
        this.helpShow = true;
      } else {
        this.helpShow = false;
      }
    },
    
    methods: {
      // 获取验证码
      getSmsCode() {
        this.$http.get('/Registered/getPhoneSmsCode', {
          params: utils.cso({
            phone: this.phone,
            phone_head: 86,
            type: 10,
            client: 'H5'
          })
        }).then((res) => {
          if (res.code >= 0) {
            this.buttonMsg = this.limitTime + 's'
            this.timer = window.setInterval(() => {
              this.limitTime--
              this.buttonMsg = this.limitTime + 's'
              if (this.limitTime < 0) {
                window.clearInterval(this.timer)
                this.buttonMsg = '发送验证码'
                this.limitTime = 60
              }
            }, 1000)
          } else {
            utils.showMessage(res.msg)
          }
        })
      },
      
      goMyself(){
        this.$router.replace({
          path: '/assistancesInvite',
          query: {
            activityId: this.$route.query.activityId,
          }
        });
      },
      
      // 确定登录
      goLogin() {
        if (this.phone) {
          if (this.smsCode) {
            this.$http({
              url: '/member/helpingHands',
              method: 'post',
              params: {
                activity_reg_id: this.$route.query.aid,
                type: 2,
                phone: this.phone,
                sms_code: this.smsCode,
                live_activity_id: this.$route.query.activityId,
              },
            }).then((res) => {
              if (res.code >= 0) {
                Cookies.set('uid', res.data.uid);
                Cookies.set('token', res.data.token.token);
                Cookies.set('reg_channel', res.data.reg_channel);
                Cookies.set('aid', res.data.activity_reg_id);
                Cookies.set('phone', res.data.phone);
                Cookies.set('help_activity_reg_id', res.data.help_activity_reg_id);
                
                
                utils.showMessage('助力成功')
                
                this.$router.replace({
                  path: '/assistancesInvite',
                  query: {
                    activityId: this.$route.query.activityId,
                  }
                });
              } else if (res.code == -3) {
                utils.showMessage(res.msg);
              } else {
                Cookies.set('uid', res.data.uid);
                Cookies.set('token', res.data.token.token);
                Cookies.set('reg_channel', res.data.reg_channel);
                Cookies.set('aid', res.data.activity_reg_id);
                Cookies.set('phone', res.data.phone);
                Cookies.set('help_activity_reg_id', res.data.help_activity_reg_id);
                
                utils.showMessage(res.msg);
                
                this.$router.replace({
                  path: '/assistancesInvite',
                  query: {
                    activityId: this.$route.query.activityId,
                  }
                });
              }
            })
          } else {
            utils.showMessage('输入的验证码不能为空')
          }
        } else {
          utils.showMessage('输入的手机号不能为空')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .assistance {
    box-sizing: border-box;
    width: 100%;
    height: 120.95rem;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    background-color: #000b2a;
    padding-top: 44.1rem;
  }
  
  .informerBtn {
    position: absolute;
    top: 2rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }
  
  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #06314e;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }
  
  .assistancePeople {
    box-sizing: border-box;
    width: 100%;
    height: 35rem;
    background-size: 100% 100%;
    padding: 0 4rem;
    padding-left: 4.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  
  .phoneInput {
    width: 100%;
    height: 4rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
    margin-bottom: 1.4rem;
  }
  
  .phoneInput[name="phoneInput"]::-webkit-input-placeholder {
    color: #642207;
  }
  
  .securityCodeInput {
    display: flex;
    height: 4rem;
    margin-bottom: 1.5rem;
  }
  
  .securityCodeInput input {
    width: 65%;
    border-radius: 4.7rem 0 0 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
  }
  
  .securityCodeInput p {
    width: 35%;
    border-radius: 0 4.7rem 4.7rem 0;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    color: #F7443F;
    padding-right: 2rem;
  }
  
  .securityCodeInput input[name="securityCode"]::-webkit-input-placeholder {
    color: #642207;
  }
  
  .beginBtn {
    width: 100%;
    height: 4rem;
    border-radius: 4.7rem;
    background: linear-gradient(170deg, #FFCE92, #C7472A);
    margin-bottom: 2.35rem;
    font-size: 1.6rem;
    font-weight: 600;
    color: #642207;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .elseGift {
    margin-top: 1rem;
    width: 100%;
  }
  
  .giftCon {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .giftCon img {
    width: 6rem;
    height: 6rem;
    padding-bottom: .85rem;
  }
  
  .giftCon p {
    font-size: 1.4rem;
    color: #642207;
    font-weight: 600;
  }
  
  .giftCon span {
    font-size: 1rem;
    color: #642207;
    font-weight: 500;
  }
  
  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  
  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }
  
  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }
  
  /* 助力提示 */
  .helpShow {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
</style>
